export const BLUEPRINT_LIST_URL = 'account/{accountId}/blueprint/list';
export const GET_BLUEPRINT_URL = 'account/{accountId}/blueprint/{blueprintId}';
export const DELETE_BLUEPRINT_URL = 'account/{accountId}/blueprint/{blueprintId}';
export const TEMP_STORAGE_UPLOAD_URL = 'account/{accountId}/upload-url';
export const BLUEPRINT_RESOURCES_URL = 'account/{accountId}/resources';

